import React, { useState } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
  FormGroup,
  Label,
  Input,
  Button,
  FormFeedback,
} from "reactstrap";
import { useTranslation } from "react-i18next";
import { GetLanguageString } from "../../helper/Components";
import { requestApi } from "../../../actions/api";
import { LoadingSpinner } from "../../../constants/const";
import Draggable from "react-draggable";

const AddBook = ({ setModal, setBooks }) => {
  const { t } = useTranslation();
  const [name, setName] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [position, setPosition] = useState({ x: 0, y: 0 });

  const toggle = () => setModal(false);

  const handleDrag = (e, ui) => {
    setPosition((prev) => ({ x: prev.x + ui.deltaX, y: prev.y + ui.deltaY }));
  };

  const validate = () => {
    if (!name.trim()) {
      setError(t("settings_name_error_message"));
      return false;
    }
    setError("");
    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;

    setLoading(true);
    try {
      const payload = { name }; // adjust if API expects other shape
      const res = await requestApi("books/").create(payload);
      setBooks(res.data);
      toggle();
    } catch (err) {
      console.error(err);
      // optionally set a generic error message
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <Draggable position={position} onDrag={handleDrag} cancel=".no-drag">
        <Modal isOpen={true} className="inmodal" autoFocus={false}>
          <ModalHeader className="modal-title" tag="h4">
            <GetLanguageString props="add_syllabus" />
          </ModalHeader>

          {!loading ? (
            <Form onSubmit={handleSubmit}>
              <ModalBody>
                <FormGroup>
                  <Label>
                    <GetLanguageString props="common_name" />
                  </Label>
                  <Input
                    autoFocus
                    type="text"
                    name="name"
                    className="ur no-drag"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    invalid={!!error}
                  />
                  {error && (
                    <FormFeedback>
                      <h4>{error}</h4>
                    </FormFeedback>
                  )}
                </FormGroup>
              </ModalBody>
              <ModalFooter>
                <Button color="white" onClick={toggle}>
                  <GetLanguageString props="common_cancel" />
                </Button>
                <Button color="primary" type="submit">
                  <GetLanguageString props="common_save_changes" />
                </Button>
              </ModalFooter>
            </Form>
          ) : (
            LoadingSpinner()
          )}
        </Modal>
      </Draggable>
    </div>
  );
};

export default AddBook;
